import { render, staticRenderFns } from "./chip.vue?vue&type=template&id=600de19c&scoped=true"
import script from "./chip.vue?vue&type=script&lang=js"
export * from "./chip.vue?vue&type=script&lang=js"
import style0 from "./chip.vue?vue&type=style&index=0&id=600de19c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600de19c",
  null
  
)

export default component.exports